import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class LocalOffersApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public listWithPageEvent(
    role: string,
    listingId?: string,
    filter?: {},
    PageEvent?: PageEvent
  ) {
    let endpoint = `admin/offers`;
    if (listingId) {
      endpoint += `/${listingId}`;
    }
    const url = this.commonFunctionService.findApiUrl('admin');
    return this.Api.getWithPageEventFilter(
      endpoint,
      PageEvent,
      filter,
      url
    ).then((ResponseBody: IResponseBody) => ResponseBody);
  }

  public save(role: string, LocalOffer) {
    return LocalOffer.offer_id
      ? this.update(role, LocalOffer)
      : this.create(role, LocalOffer);
  }

  private update(role: string, LocalOffer) {
    const endpoint = `${role}/local-offer/${LocalOffer.offer_id}`;

    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.put(endpoint, LocalOffer, url).then(
      (id) => {
        this.Api.handleSuccess(LocalOffer.offer + ' saved.');
        return id;
      },
      (error) => this.Api.handleError(error)
    );
  }

  private create(role: string, LocalOffer) {
    const endpoint = `${role}/local-offer`;

    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, LocalOffer, url).then(
      (id) => {
        this.Api.handleSuccess(LocalOffer.offer + ' saved.');
        return id;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public delete(role: string, LocalOffer) {
    const endpoint = `${role}/offer/${LocalOffer.offer_id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url)
      .then(() => this.Api.handleSuccess(LocalOffer.offer + ' deleted.'))
      .catch((error) => this.Api.handleError(error));
  }

  public deleteLocation(role, locationId) {
    const endpoint = `${role}/offer/location/${locationId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url);
  }
}
